import { useTranslation } from "react-i18next";

import { WorkdayCollapsibleTile } from "../WorkdayCollapsibleTile";
import { getMeetingsByDate, getMeetingsByWorkday, getMeetingsOutsideOfWorkdays, useAppSelector } from "@lib/store";
import { LocalDateString, Workday } from "@lib/store/src/data/timeslots/apiTypes";
import { useMemoDate } from "@lib/store/src/ui/hooks/useMemoDate";
import { cn } from "@utils";

interface WorkdayMeetingsSectionProps {
  workday?: Workday;
  selectedDate: LocalDateString;
  initialOpen?: boolean;
  isUnknownLocation?: boolean;
  handleClassName?: string;
  onPress?: () => void;
}

export const WorkdayMeetingsSection = ({
  workday,
  selectedDate,
  onPress,
  initialOpen = false,
  handleClassName,
  isUnknownLocation = false,
}: WorkdayMeetingsSectionProps) => {
  const { t } = useTranslation();
  const date = useMemoDate(selectedDate);

  const meetingsForWorkdayOrDate = useAppSelector(state =>
    workday ? getMeetingsByWorkday(state, workday) : getMeetingsByDate(state, date),
  );

  const meetingsOutsideOfWorkdays = useAppSelector(state => getMeetingsOutsideOfWorkdays(state, selectedDate));

  const meetings = isUnknownLocation ? meetingsOutsideOfWorkdays : meetingsForWorkdayOrDate;

  if (!meetings.length) {
    return null;
  }

  return (
    <WorkdayCollapsibleTile
      handle={
        meetings.length ? (
          t("timeslots:Meeting", { count: meetings.length })
        ) : (
          <p className="text-[15px] text-gray-500">{t("timeslots:NoMeetings")}</p>
        )
      }
      icon="speechBubbles"
      handleClassName={cn("border-b-0", handleClassName, {
        "[&:not(:only-child)]:border-t": workday !== undefined,
      })}
      toggleChevronOnPress
      initialOpen={initialOpen}
      disabled={!meetings.length}
      onPress={onPress}
    />
  );
};
